import { Eye } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgViewShow = mkIcon(Eye);